//@import dependencies
import React, {useState, useEffect, ChangeEvent, useCallback} from 'react'
import { useTranslation } from 'react-i18next'
import { Controller, useForm } from 'react-hook-form'
import { store } from 'app_storage/redux-storage';
import { Form } from 'react-bootstrap'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import parse from 'html-react-parser';

import EditorJS from 'react-editor-js'
// @ts-ignore
import Embed from '@editorjs/embed'
// @ts-ignore
import Header from '@editorjs/header'
// @ts-ignore
import Image from '@editorjs/image'
// @ts-ignore
import LinkE from '@editorjs/link'
// @ts-ignore
import List from '@editorjs/list'
// @ts-ignore
import Paragraph from '@editorjs/paragraph'
// @ts-ignore
import Raw from '@editorjs/raw'
// @ts-ignore
import Checklist from '@editorjs/checklist'
//@end

// @import configs
import { external_api } from 'app_config/globals';
// @end

//@import components
import ReactSelectComponent from 'app_components/commons/reactSelect'
import IconComponent from 'app_components/commons/icons'
import ModalContentForm from 'app_components/modules/admin/course/modalContentForm'
//@end

// @import hooks
import { useColors } from 'app_hooks/useColors';
// @end

// @INFO Import types
// @end

// @INFO Import services
import CourseSchedulingModeMasterService from 'app_services/admin/courseScheduling/courseSchedulingModeMasterService'
import EditorjsService from 'app_services/components/editorjs/editorjsService';
import ProgramMasterService from 'app_services/admin/program/programMasterService'
// @end

// @INFO Import Styles
import './../courseModule.scss'
import moment from 'moment';
import CourseFilterTermSelect from 'app_components/modules/CourseFilterTermSelect/CourseFilterTermSelect';
import CourseService from 'app_services/admin/course/courseService';
import SavingIndicator, { TypesStateSavingIndicator } from 'app_components/commons/SavingIndicator/SavingIndicator';
import LabelComponent from 'app_components/commons/LabelComponent/LabelComponent';
import { CourseFormationType } from 'app_types/admin/course/courseTypes';
import { FORMATION_TYPE_TRANSLATIONS } from 'app_types/campus/academic/courseTypes';

const Quote = require('@editorjs/quote');
const Table = require('@editorjs/table')
const uuid = require('react-uuid')

const FORMATION_TYPE_OPTIONS = [
  {
    label: FORMATION_TYPE_TRANSLATIONS[CourseFormationType.COURSE],
    value: CourseFormationType.COURSE
  },
  {
    label: FORMATION_TYPE_TRANSLATIONS[CourseFormationType.PROGRAM],
    value: CourseFormationType.PROGRAM
  },
  {
    label: FORMATION_TYPE_TRANSLATIONS[CourseFormationType.DIPLOMA],
    value: CourseFormationType.DIPLOMA
  },
]

// @ADD Component types
interface ICourseModuleLayoutProps {
  onHandleSubmit: (data: any) => void
  editData?: any
  customErrors?: any
  viewer: boolean
}

const SLUG_VALIDATION_TIMEOUT = 500

const CourseModuleLayout: React.FC<ICourseModuleLayoutProps> = (props) => {

  const [colors] = useColors()
  const editorjsService = new EditorjsService()

  const exampleData = {
    blocks: [{
      type: 'header',
      data: {
        text: 'Sin titulo',
        level: 2
      }
    }],
    time: new Date().getTime(),
    version: '2.19.0'
  }

  const courseSchedulingModeMasterService: CourseSchedulingModeMasterService = new CourseSchedulingModeMasterService()
  const programMasterService: ProgramMasterService = new ProgramMasterService()

  const [modalContentFormStatus, setModalContentFormStatus] = useState<boolean>(false)
  const [contentEditData, setContentEditData] = useState<any>(null)
  const [highlighted, setHighlighted] = useState<boolean>(false)

  const [editorDataShortDescription, updateEditorDataShortDescription] = useState<undefined | any>(null)
  const [editorDataDescription, updateEditorDataDescription] = useState<undefined | any>(null)
  const [editorDataCompetencies, updateEditorDataCompetencies] = useState<undefined | any>(null)
  const [editorDataObjectives, updateEditorDataObjectives] = useState<undefined | any>(null)
  const [editorDataFocus, updateEditorDataFocus] = useState<undefined | any>(null)
  const [editorDataMaterials, updateEditorDataMaterials] = useState<undefined | any>(null)
  const [editorDataImportantInfo, updateEditorDataImportantInfo] = useState<undefined | any>(null)
  const [editorDataMethodology, updateEditorDataMethodology] = useState<undefined | any>(null)
  const [editorDataGeneralities, updateEditorDataGeneralities] = useState<undefined | any>(null)
  const [slugState, setSlugState] = useState<TypesStateSavingIndicator>('saving')
  const [slug, setSlug] = useState<string>(props?.editData?.slug)
  // const [editorDataRequirements, updateEditorDataRequirements] = useState<undefined | any>(null)

  const [firstLoad, setFirstLoad] = useState(true);

  const [listOfModes, setListOfModes] = useState<Array<any>>([])
  const [listOfPrograms, setListOfPrograms] = useState<Array<any>>([])
  const [listOfContent, setListOfContent] = useState<Array<any>>([])

  const { t } = useTranslation()

  const formHook = useForm()
  const storeObject = store

  // Configuración del editor
  const EDITOR_TOOLS = {
    embed: {
      class: Embed,
      inlineToolbar: true
    },
    header: {
      class: Header,
      inlineToolbar: true
    },
    image: {
      class: Image,
      config: {
        endpoints: {
          byFile: `${external_api.backend.url}/api/admin/editor-js/image/upload-by-file`,
          byUrl: `${external_api.backend.url}/api/admin/editor-js/image/upload-by-url`
        },
        additionalRequestHeaders: {
          'Authorization': storeObject.getState().auth.user?.token ? storeObject.getState().auth.user?.token : ''
        },
        additionalRequestData: {
          // id: responseAPI ? responseAPI.academic_resource : ''
        }
      }
    },
    linkTool: {
      class: LinkE,
      config: {
        endpoint: `${external_api.backend.url}/api/admin/editor-js/link/fetch-url`
      }
    },
    quote: {
      class: Quote,
      inlineToolbar: true,
      shortcut: 'CMD+SHIFT+O',
      config: {
        quotePlaceholder: 'Enter a quote',
        captionPlaceholder: 'Quote\'s author',
      },
    },
    paragraph: {
      class: Paragraph,
      inlineToolbar: true
    },
    list: {
      class: List,
      inlineToolbar: true
    },
    raw: {
      class: Raw,
      inlineToolbar: true
    },
    checklist: {
      class: Checklist,
      inlineToolbar: true
    },
    table: {
      class: Table,
      inlineToolbar: true
    },
  }

  useEffect(() => {
    getModes()
  }, [])

  useEffect(() => {
    if (props?.editData) {
      if (firstLoad) {
        updateEditorDataShortDescription((props?.editData?.details?.short_description) ? props?.editData?.details?.short_description : exampleData)
        updateEditorDataDescription((props?.editData?.details?.description) ? props?.editData?.details?.description : exampleData)
        updateEditorDataCompetencies((props?.editData?.details?.competencies) ? props?.editData?.details?.competencies : exampleData)
        updateEditorDataObjectives((props?.editData?.details?.objectives) ? props?.editData?.details?.objectives : exampleData)
        updateEditorDataFocus((props?.editData?.details?.focus) ? props?.editData?.details?.focus : exampleData)
        updateEditorDataMaterials((props?.editData?.details?.materials) ? props?.editData?.details?.materials : exampleData)
        updateEditorDataImportantInfo((props?.editData?.details?.important_info) ? props?.editData?.details?.important_info : exampleData)
        updateEditorDataMethodology((props?.editData?.details?.methodology) ? props?.editData?.details?.methodology : exampleData)
        updateEditorDataGeneralities((props?.editData?.details?.generalities) ? props?.editData?.details?.generalities : exampleData)

        setHighlighted((props?.editData?.details?.highlighted) ? props?.editData?.details?.highlighted : false)

        if (props?.editData?.details?.schedulingMode) {
          getPrograms(parseInt(props?.editData?.details?.schedulingMode.moodle_id))
        }

        if (props?.editData?.details?.content && Array.isArray(props?.editData?.details?.content) && props?.editData?.details?.content.length > 0) {
          let items = props?.editData?.details?.content.reduce((accum: any, element: any) => {
            accum.push({
              ...element,
              uuid: uuid(),
              // data: element.data ? JSON.parse(element.data): {}
            })
            return accum
          }, [])
          setListOfContent(items)
          formHook.setValue('content', items)
        }

        setFirstLoad(false)
      }
    } else {
      updateEditorDataShortDescription(exampleData)
      updateEditorDataDescription(exampleData)
      updateEditorDataCompetencies(exampleData)
      updateEditorDataObjectives(exampleData)
      updateEditorDataFocus(exampleData)
      updateEditorDataMaterials(exampleData)
      updateEditorDataImportantInfo(exampleData)
      updateEditorDataMethodology(exampleData)
      updateEditorDataGeneralities(exampleData)
    }
  }, [props,props.editData])

  const getModes = async () => {
    const items: Array<any> = []
    const response = await courseSchedulingModeMasterService.list()
    if (response?.categories) {
      response?.categories.map((item: any) => {
       items.push({ value: item.id, label: item.name })
      })
    }
    setListOfModes(items)
  }

  const getPrograms = async (categoryId: number) => {
    const programs: Array<any> = []
    const programsResponse = await programMasterService.list({
      categoryId
    })
    if (programsResponse?.courses) {
      programsResponse.courses.map((program: any) => {
        programs.push({ value: program.id, label: `${program.name} | ${program.fullname}` })
      })
    }
    setListOfPrograms(programs)
  }

  /**
   * @INFO Referencia del cambio del editor
   * @param data
   */
  const handleChangeEditor = (api: any, data?: any) => {
    if(data){
      let dataToSave = exampleData
      if (data.blocks && data.blocks.length > 0) {
        dataToSave = data
      }
      switch (api) {
        case 'short_description':
          updateEditorDataShortDescription(dataToSave)
          break;
        case 'description':
          updateEditorDataDescription(dataToSave)
          break;
        case 'competencies':
          updateEditorDataCompetencies(dataToSave)
          break;
        case 'objectives':
          updateEditorDataObjectives(dataToSave)
          break;
        case 'focus':
          updateEditorDataFocus(dataToSave)
          break;
        case 'materials':
          updateEditorDataMaterials(dataToSave)
          break;
        case 'important_info':
          updateEditorDataImportantInfo(dataToSave)
          break;
        case 'methodology':
          updateEditorDataMethodology(dataToSave)
          break;
        case 'generalities':
          updateEditorDataGeneralities(dataToSave)
          break;
        default:
          break;
      }
    }
  }

  const modalityChange = (data: any) => {
    formHook.setValue('program', null)
    if (data?.value) {
      getPrograms(data.value)
    }
  }

  const handleModalContentForm = () => {
    setModalContentFormStatus(true)
  }

  const editContent = (content: number) => {
    setContentEditData(content)
    setModalContentFormStatus(true)
  }

  const removeContentItem = (index: number) => {
    let items = [...listOfContent]
    items.splice(index, 1)
    setListOfContent(items)
    formHook.setValue('content', items)
  }

  const handleCloseModal = (data: any) => {
    setContentEditData(null)
    setModalContentFormStatus(false)

    if (data?.status === true && data?.data) {
      let items = [...listOfContent]
      if (data?.data?.uuid) {
        const find = items.findIndex((content) => content.uuid === data?.data?.uuid)
        if (find !== -1) {
          items[find] = {
            uuid: data?.data?.uuid,
            data: data?.data?.data,
            name: data?.data?.name
          }
        }
      } else {
        items.push({
          uuid: uuid(),
          data: data?.data?.data,
          name: data?.data?.name
        })
      }
      setListOfContent(items)
      formHook.setValue('content', items)
    }
  }

  const handleChangeHighlighted = (e: any) => {
    setHighlighted(!highlighted)
  }

  const handleChangeSlug = (e: ChangeEvent<HTMLInputElement>) => {
    const text = e.target.value ? e.target.value : ''
    const formattedText = text.toLowerCase()
        .replaceAll(/[^a-zA-Z0-9 \-_]/g, '')
        .replaceAll(' ', '-')
    setSlug(formattedText)
  }

  const handleValidateSlug = useCallback(async () => {
    setSlugState('saving')
    const courseService = new CourseService()
    const response = await courseService.validateSlug(props?.editData?._id, slug)
    if (response.code === 200) {
      setSlugState('saved')
      return true
    } else {
      setSlugState('failed')
      return false
    }
  }, [props?.editData?._id, slug])

  useEffect(() => {
    const timeout = setTimeout(() => {
      handleValidateSlug()
    }, [SLUG_VALIDATION_TIMEOUT])
    return () => {
      clearTimeout(timeout)
    }
  }, [handleValidateSlug])

  const handleSubmit = (callback: any) => async (params: any) => {
    params.slug = slug
    callback(params)
  }

  return(
    <div className='course-form'>
      <fieldset disabled={props.viewer ? true : false}>
        <form onSubmit={formHook.handleSubmit(handleSubmit(props.onHandleSubmit))}>

          <div className="d-flex align-items-center mb-2">
            <h3 className="form-title">{t("modules.courses.general_information")}</h3>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <Form.Check
                  type='switch'
                  id='highlighted'
                  name='highlighted'
                  label={t('labels.courses.highlighted')}
                  onChange={(event: any) => handleChangeHighlighted(event)}
                  checked={highlighted}
                  ref={formHook.register()}
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='schedulingMode'>{t('labels.courses.schedulingMode')}</label>
                <ReactSelectComponent
                  identifier='schedulingMode'
                  options={listOfModes}
                  formHooks={formHook}
                  defaultValue={(props?.editData?.details?.schedulingMode) ? [{value: parseInt(props?.editData?.details?.schedulingMode.moodle_id), label: props?.editData?.details?.schedulingMode.name}] : []}
                  isMulti={false}
                  required={true}
                  onChangeSelect={modalityChange}
                />
                {formHook.errors.schedulingMode && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='program'>{t('labels.courses.program')}</label>
                <div className="program-field">
                  <ReactSelectComponent
                    identifier='program'
                    options={listOfPrograms}
                    formHooks={formHook}
                    defaultValue={(props?.editData?.details?.program) ? [{value: parseInt(props?.editData?.details?.program.moodle_id), label: `${props?.editData?.details?.program.code} | ${props?.editData?.details?.program.name}`}] : []}
                    isMulti={false}
                    required={true}
                  />
                  {formHook.errors.program && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                </div>
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='courseType'>{t('labels.courses.courseType')}</label>
                  {formHook.errors.courseType && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  <input
                    id='courseType'
                    name='courseType'
                    className={`form-control ${formHook.errors.courseType && 'is-invalid'}`}
                    type='text'
                    ref={formHook.register({ required: true })}
                    defaultValue={props?.editData?.details?.courseType}
                  />
              </div>
            </div>

            <div className="col-md-12">
                <div className='form-group '>
                  <label htmlFor='formationType'>Tipo de formación</label>
                  {formHook.errors?.formationType && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  <ReactSelectComponent
                    identifier='formationType'
                    options={FORMATION_TYPE_OPTIONS}
                    formHooks={formHook}
                    defaultValue={(props?.editData?.details?.formationType) ? [{ value: props?.editData?.details?.formationType, label: FORMATION_TYPE_TRANSLATIONS[props?.editData?.details?.formationType as CourseFormationType] }] : []}
                    isMulti={false}
                    required={true}
                    />
                  {formHook?.errors?.formationType && <div className='custom-invalid-feedback'>El tipo de formación es obligatorio</div>}
                </div>
              </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='slug'>Slug</label>
                  {formHook.errors.slug && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  <input
                    className={`form-control ${formHook.errors.slug && 'is-invalid'}`}
                    type='text'
                    onChange={handleChangeSlug}
                    value={slug}
                  />
                  {!!slug?.length && (
                    <div className='mt-1'>
                      <SavingIndicator
                        state={slugState}
                        savedText='Este slug esta disponible'
                        failedText='Este slug ya se encuentra en uso'
                        savingText='Validando slug'
                        withText
                      />
                    </div>
                  )}
                  {!slug?.length && (
                    <LabelComponent color='var(--danger)'>Este campo es requerido</LabelComponent>
                  )}
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='filterCategories'>Categorías de filtro</label>
                <CourseFilterTermSelect
                  defaultValue={props?.editData?.details?.filterCategories}
                  name='filterCategories'
                  formHook={formHook}
                />
              </div>
            </div>
          </div>

          <div className="d-flex align-items-center mb-2">
            <h3 className="form-title">{t("modules.courses.course_configuration")}</h3>
          </div>

          <div className="row">

            <div className="col-md-12">
              <div className="form-group">
                <div className='d-flex' style={{ justifyContent: 'space-between' }}>
                  <label htmlFor='alternative_title'>{t('labels.courses.alternative_title')}</label>
                  <div className="form-group">
                    <Form.Check
                      type='switch'
                      id='is_alternative_title_active'
                      name='is_alternative_title_active'
                      label=''
                      defaultChecked={props?.editData?.details?.is_alternative_title_active}
                      ref={formHook.register()}
                    />
                  </div>
                </div>
                {formHook.errors.alternative_title && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <input
                  id='alternative_title'
                  name='alternative_title'
                  type='text'
                  className={`form-control ${formHook.errors.alternative_title && 'is-invalid'}`}
                  ref={formHook.register({ required: false })}
                  defaultValue={props?.editData?.details?.alternative_title}
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='duration'>{t('labels.courses.duration')}</label>
                {formHook.errors.duration && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <input
                  id='duration'
                  name='duration'
                  type='text'
                  className={`form-control ${formHook.errors.duration && 'is-invalid'}`}
                  ref={formHook.register({ required: false })}
                  defaultValue={props?.editData?.details?.duration}
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group form-editor-js">
                <label htmlFor='short_description'>{t('labels.courses.short_description')}</label>
                <input
                  id="short_description"
                  type="hidden"
                  name="short_description"
                  ref={formHook.register({ required: false })}
                  defaultValue={props?.editData?.details?.short_description}
                  value={(editorDataShortDescription) ? JSON.stringify(editorDataShortDescription) : ''}
                />
                {editorDataShortDescription && (
                  <EditorJS
                    tools={EDITOR_TOOLS}
                    data={editorDataShortDescription}
                    onChange={(api: any, data?: any) => handleChangeEditor('short_description', data)}
                    autofocus={true}
                  />
                )}
                {formHook.errors.short_description && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group form-editor-js">
                <label htmlFor='description'>{t('labels.courses.description')}</label>
                <input
                  id="description"
                  type="hidden"
                  name="description"
                  ref={formHook.register({ required: true })}
                  defaultValue={props?.editData?.details?.description}
                  value={(editorDataDescription) ? JSON.stringify(editorDataDescription) : ''}
                />
                {editorDataDescription && (
                  <EditorJS
                    tools={EDITOR_TOOLS}
                    data={editorDataDescription}
                    onChange={(api: any, data?: any) => handleChangeEditor('description', data)}
                    autofocus={true}
                  />
                )}
                {formHook.errors.description && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div>

            <div className="col-md-12">
              <div className="row">
                <div className="col-6">
                  <div className='form-group'>
                    <label htmlFor='cover'>{t('labels.courses.cover')}</label>
                    {formHook.errors.cover && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                    <input
                      id='cover'
                      name='cover'
                      className='form-control-file'
                      type='file'
                      ref={formHook.register({ required: false })}
                    />
                    {formHook.errors.cover && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  </div>
                </div>
                {props?.editData?.details?.coverUrl && (
                  <div className="col-md-6">
                    <div className="form-group">
                        <div className="cover-container">
                          <img src={props?.editData?.details?.coverUrl} alt=""/>
                        </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <>
              <div className="col-md-12">
                <div className='form-group '>
                  <label htmlFor='platform_video'>{t('labels.courses.platform_video')}</label>
                  {formHook.errors?.platform_video && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  <ReactSelectComponent
                    identifier='platform_video'
                    options={[{ label: 'youtube', value: 'youtube' }, { label: 'vimeo', value: 'vimeo' }]}
                    formHooks={formHook}
                    defaultValue={(props?.editData?.details?.platform_video) ? [{ value: props?.editData?.details?.platform_video, label: props?.editData?.details?.platform_video }] : []}
                    isMulti={false}
                    required={false}
                    />
                  {props.customErrors?.platform_video && <div className='custom-invalid-feedback'>{props.customErrors?.platform_video}</div>}
                </div>
              </div>
              <div className="col-md-12">
                <div className='form-group '>
                  <label htmlFor='url_video'>{t('labels.courses.url_video')}</label>
                  {formHook.errors?.url_video && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  <input
                    id='url_video'
                    name='url_video'
                    className={`form-control ${formHook.errors?.url_video && 'is-invalid'}`}
                    type='text'
                    ref={formHook.register({ required: false })}
                    defaultValue={props?.editData?.details?.url_video}
                  />
                  {props.customErrors?.url_video && <div className='custom-invalid-feedback'>{props.customErrors?.url_video}</div>}
                </div>
              </div>
            </>

            <div className="col-md-12">
              <div className="form-group form-editor-js">
                <label htmlFor='competencies'>{t('labels.courses.competencies')}</label>
                <input
                  id="competencies"
                  type="hidden"
                  name="competencies"
                  ref={formHook.register({ required: false })}
                  defaultValue={props?.editData?.details?.competencies}
                  value={(editorDataCompetencies) ? JSON.stringify(editorDataCompetencies) : ''}
                />
                {editorDataCompetencies && (
                  <EditorJS
                    tools={EDITOR_TOOLS}
                    data={editorDataCompetencies}
                    onChange={(api: any, data?: any) => handleChangeEditor('competencies', data)}
                    autofocus={true}
                  />
                )}
                {formHook.errors.competencies && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group form-editor-js">
                <label htmlFor='objectives'>{t('labels.courses.objectives')}</label>
                <input
                  id="objectives"
                  type="hidden"
                  name="objectives"
                  ref={formHook.register({ required: false })}
                  defaultValue={props?.editData?.details?.objectives}
                  value={(editorDataObjectives) ? JSON.stringify(editorDataObjectives) : ''}
                />
                {editorDataObjectives && (
                  <EditorJS
                    tools={EDITOR_TOOLS}
                    data={editorDataObjectives}
                    onChange={(api: any, data?: any) => handleChangeEditor('objectives', data)}
                    autofocus={true}
                  />
                )}
                {formHook.errors.objectives && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group form-editor-js">
                <label htmlFor='focus'>{t('labels.courses.focus')}</label>
                <input
                  id="focus"
                  type="hidden"
                  name="focus"
                  ref={formHook.register({ required: false })}
                  defaultValue={props?.editData?.details?.focus}
                  value={(editorDataFocus) ? JSON.stringify(editorDataFocus) : ''}
                />
                {editorDataFocus && (
                  <EditorJS
                    tools={EDITOR_TOOLS}
                    data={editorDataFocus}
                    onChange={(api: any, data?: any) => handleChangeEditor('focus', data)}
                    autofocus={true}
                  />
                )}
                {formHook.errors.focus && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div>


            <div className="col-md-12">
              <div className="form-group form-editor-js">
                <label htmlFor='materials'>{t('labels.courses.materials')}</label>
                <input
                  id="materials"
                  type="hidden"
                  name="materials"
                  ref={formHook.register({ required: false })}
                  defaultValue={props?.editData?.details?.materials}
                  value={(editorDataMaterials) ? JSON.stringify(editorDataMaterials) : ''}
                />
                {editorDataMaterials && (
                  <EditorJS
                    tools={EDITOR_TOOLS}
                    data={editorDataMaterials}
                    onChange={(api: any, data?: any) => handleChangeEditor('materials', data)}
                    autofocus={true}
                  />
                )}
                {formHook.errors.materials && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group form-editor-js">
                <label htmlFor='important_info'>{t('labels.courses.important_info')}</label>
                <input
                  id="important_info"
                  type="hidden"
                  name="important_info"
                  ref={formHook.register({ required: false })}
                  defaultValue={props?.editData?.details?.important_info}
                  value={(editorDataImportantInfo) ? JSON.stringify(editorDataImportantInfo) : ''}
                />
                {editorDataImportantInfo && (
                  <EditorJS
                    tools={EDITOR_TOOLS}
                    data={editorDataImportantInfo}
                    onChange={(api: any, data?: any) => handleChangeEditor('important_info', data)}
                    autofocus={true}
                  />
                )}
                {formHook.errors.important_info && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group form-editor-js">
                <label htmlFor='methodology'>{t('labels.courses.methodology')}</label>
                <input
                  id="methodology"
                  type="hidden"
                  name="methodology"
                  ref={formHook.register({ required: false })}
                  defaultValue={props?.editData?.details?.methodology}
                  value={(editorDataMethodology) ? JSON.stringify(editorDataMethodology) : ''}
                />
                {editorDataMethodology && (
                  <EditorJS
                    tools={EDITOR_TOOLS}
                    data={editorDataMethodology}
                    onChange={(api: any, data?: any) => handleChangeEditor('methodology', data)}
                    autofocus={true}
                  />
                )}
                {formHook.errors.methodology && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group form-editor-js">
                <label htmlFor='generalities'>{t('labels.courses.generalities')}</label>
                <input
                  id="generalities"
                  type="hidden"
                  name="generalities"
                  ref={formHook.register({ required: false })}
                  defaultValue={props?.editData?.details?.generalities}
                  value={(editorDataGeneralities) ? JSON.stringify(editorDataGeneralities) : ''}
                />
                {editorDataGeneralities && (
                  <EditorJS
                    tools={EDITOR_TOOLS}
                    data={editorDataGeneralities}
                    onChange={(api: any, data?: any) => handleChangeEditor('generalities', data)}
                    autofocus={true}
                  />
                )}
                {formHook.errors.generalities && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div>

            {/* <div className="col-md-6">
              <div className="form-group">
                <label htmlFor='requirements'>{t('labels.courses.requirements')}</label>
                <input
                  id="requirements"
                  type="hidden"
                  name="requirements"
                  ref={formHook.register({ required: true })}
                  defaultValue={props?.editData?.details?.requirements}
                  value={(editorDataRequirements) ? JSON.stringify(editorDataRequirements) : ''}
                />
                {editorDataRequirements && (
                  <EditorJS
                    tools={EDITOR_TOOLS}
                    data={editorDataRequirements}
                    onChange={handleChangeEditorRequirements}
                    autofocus={true}
                  />
                )}
                {formHook.errors.requirements && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div> */}

            {/* <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='name'>{t('labels.courses.name')}</label>
                  {formHook.errors.name && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  <input
                    id='name'
                    name='name'
                    className={`form-control ${formHook.errors.name && 'is-invalid'}`}
                    type='text'
                    ref={formHook.register({ required: true })}
                    defaultValue={props?.editData?.details?.name}
                  />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='content'>{t('labels.courses.content')}</label>
                <input
                  id="content"
                  type="hidden"
                  name="content"
                  ref={formHook.register({ required: true })}
                  defaultValue={props?.editData?.details?.subtitle}
                  value={(editorData) ? JSON.stringify(editorData) : ''}
                />
                {editorData && (
                  <EditorJS
                    tools={EDITOR_TOOLS}
                    data={editorData}
                    // readOnly={!editState}
                    onChange={handleChangeEditor}
                    autofocus={true}
                  />
                )}
                {formHook.errors.content && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div> */}
          </div>
          <div className="row mb-3">
            {!props.viewer && (
              <div className="col-12 text-right">
                <button className="btn btn-primary" onClick={handleModalContentForm} type="button">
                  <IconComponent fontawesome={{icon: 'fa fa-plus'}} />&nbsp;&nbsp;
                  {t("modules.courses.form.add_content")}
                </button>
              </div>
              )}

              <div className="col-12 content-list mt-3">
                {listOfContent.map((content, index) => (
                  <div className="content-item">
                    <div className="content-index">{index+1}</div>
                    <div className="content-content">
                      <div>
                        {/* <span>{content?.data?.blocks ? content?.data?.blocks : 'hola'}</span>
                        <span>{content.data}</span> */}
                        {/* <span>{editorjsService.jsonToComponent(content?.data?.blocks ? content?.data?.blocks : [])}</span> */}
                        <span>{parse(editorjsService.jsonToHtml(content?.data?.blocks ? content?.data?.blocks : []))}</span>
                      </div>
                    </div>
                    {!props.viewer && (
                      <div className="content-actions">
                        <OverlayTrigger
                          trigger={['hover', 'focus']}
                          placement={'top'}
                          overlay={
                            <Tooltip id='toolip-circle'>
                              {t("modules.courses.form.content.edit")}
                            </Tooltip>
                          }>
                          <div className="content-action" onClick={() => editContent(content)}>
                            <IconComponent fontawesome={{icon: 'fas fa-edit'}} color={colors.primary} />
                          </div>
                        </OverlayTrigger>
                        &nbsp;&nbsp;
                        <OverlayTrigger
                          trigger={['hover', 'focus']}
                          placement={'top'}
                          overlay={
                            <Tooltip id='toolip-circle'>
                              {t("modules.courses.form.content.delete")}
                            </Tooltip>
                          }>
                            <div className="content-action" onClick={() => removeContentItem(index)}>
                              <IconComponent fontawesome={{icon: 'fas fa-trash-alt'}} color={colors.primary} />&nbsp;&nbsp;
                            </div>
                        </OverlayTrigger>
                      </div>
                    )}
                  </div>
                ))}
                {formHook.register({name: 'content', required: true, value: listOfContent})}
              </div>

          </div>

          <div className="d-flex align-items-center mb-2">
            <h3 className="form-title">{t("modules.courses.new_dates")}</h3>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='new_start_date'>{t('labels.courses.new_start_date')}</label>
                  {formHook.errors.new_start_date && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  <input
                    id='new_start_date'
                    name='new_start_date'
                    className={`form-control ${formHook.errors.new_start_date && 'is-invalid'}`}
                    type='date'
                    ref={formHook.register({ required: true })}
                    defaultValue={moment(props?.editData?.details?.new_start_date).format('YYYY-MM-DD')}
                  />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='new_end_date'>{t('labels.courses.new_end_date')}</label>
                  {formHook.errors.new_end_date && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                  <input
                    id='new_end_date'
                    name='new_end_date'
                    className={`form-control ${formHook.errors.new_end_date && 'is-invalid'}`}
                    type='date'
                    ref={formHook.register({ required: true })}
                    defaultValue={moment(props?.editData?.details?.new_end_date).format('YYYY-MM-DD')}
                  />
              </div>
            </div>
          </div>

{/*

          <div className="d-flex align-items-center mb-2">
            <h3 className="form-title">{t("modules.courses.course_configuration")}</h3>
          </div>

          <div className="row">



            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='mode'>{t('labels.courses.mode')}</label>
                <ReactSelectComponent
                  identifier='mode'
                  options={listOfCourseModes}
                  formHooks={formHook}
                  defaultValue={(props?.editData?.details?.mode) ? [{value: props?.editData?.details?.mode._id, label: props?.editData?.details?.mode.description}] : []}
                  isMulti={false}
                  required={true}
                />
                {formHook.errors.mode && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div>


            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='maxEnrollmentDate'>{t('labels.courses.maxEnrollmentDate')}</label>
                <input
                  type='date'
                  className='form-control'
                  name='maxEnrollmentDate'
                  defaultValue={moment.utc(props?.editData?.details?.maxEnrollmentDate).format('YYYY-MM-DD') || moment.utc().format('YYYY-MM-DD')}
                  ref={formHook.register({ required: true })}
                />
                {formHook.errors.maxEnrollmentDate && <div className='custom-invalid-feedback'>{t('errors.this_field_is_required')}</div>}
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='lang'>{t('labels.courses.lang')}</label>
                {formHook.errors.lang && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <select
                  name="lang"
                  className='form-control'
                  defaultValue={props?.editData?.details?.lang}
                  ref={formHook.register({ required: true })}
                >
                  <option value="es">Español</option>
                  <option value="en">Ingles</option>
                </select>
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='quota'>{t('labels.courses.quota')}</label>
                {formHook.errors.quota && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <input
                  id='quota'
                  name='quota'
                  className={`form-control ${formHook.errors.quota && 'is-invalid'}`}
                  type='number'
                  ref={formHook.register({ required: false })}
                  defaultValue={props?.editData?.details?.quota}
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='duration'>{t('labels.courses.duration')}</label>
                {formHook.errors.duration && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <input
                  id='duration'
                  name='duration'
                  className={`form-control ${formHook.errors.duration && 'is-invalid'}`}
                  type='text'
                  placeholder='0h 0m 0s'
                  ref={formHook.register({ required: true })}
                  defaultValue={(props?.editData?.details?.duration) ? getDurationFormated(props?.editData?.details?.duration) : ''}
                />
              </div>
              {props.customErrors?.duration_invalid && <div className='custom-invalid-feedback'>{props.customErrors?.duration_invalid}</div>}
            </div>

          </div> */}

          {!props.viewer && (
            <div className='buttons-group'>
              <div className='text-right'>
                <button
                  className='btn btn-primary'
                  type='submit'
                  disabled={!slug?.length || slugState !== 'saved'}
                >
                  {t('buttons.save')}
                </button>
              </div>
            </div>
          )}

        </form>


      </fieldset>

      {modalContentFormStatus && (
        <ModalContentForm
          open={modalContentFormStatus}
          handleClose={handleCloseModal}
          editData={contentEditData}
        />
      )}
    </div>
  )
}

export default CourseModuleLayout
